import React, { Component } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import playbutton from "views/ITV-details/img/playbutton.svg";
// import Swiper core and required modules
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper/core";
import banner1 from "views/ITV-details/img/banner.png";
//IMG
import { connect } from "react-redux";
import Token from "api/Auth/auth";
import { setMgToken, setHcToken } from "store/Auth";
import store from "store.js";
import { getITVAction } from "store/Home";

// install Swiper modules
SwiperCore.use([EffectFade, Navigation, Pagination]);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      filter: false,
      search: "",
      playing: false,
    };
  }
  async componentDidMount() {
    let HcToken = await Token.getToken();
    store.dispatch(setHcToken(HcToken));
    let MgToken = await Token.getTokenMagitt();
    store.dispatch(setMgToken(MgToken));
    let responseGetItv = await this.props.getITVAction();
    this.setState({ jobs: responseGetItv });
  }
  render() {
    return (
      <>
        <Swiper
          spaceBetween={30}
          effect={"fade"}
          navigation={false}
          pagination={{
            clickable: true,
          }}
          className="mySwiper"
        >
          {this.state.jobs
            .slice(0, 3)
            // .filter((val)=> {val.b_title.includes(`'${this.state.search}'`)})
            .map((val, index) => {
              return (
                <SwiperSlide className="relative ">
                  <video
                    onPlay={() => this.setState({ playing: true })}
                    onPause={() => this.setState({ playing: false })}
                    controls
                    className="w-full rounded-15px sm-h-198px max-h-641vh bg-black"
                  >
                    <source
                      src={
                        process.env.REACT_APP_IMAGE_BASE_MG + "/" + val.b_path
                      }
                      alt="jobvideo"
                      type="video/mp4"
                      className="w-full rounded-t-15px sm-rounded-12px sm-h-198px max-h-641vh bg-black"
                    />
                  </video>
                  {!this.state.playing ? (
                    <div className="inside-listing absolute lg:w-1/3 md:w-1/3 text-left sm-top-20per">
                      <h1 className="text-white font-semibold sm-fsize16">
                        {val.b_title || "JOB VIDEO"}
                      </h1>
                      <p className="text-white fsize18 text-left sm-fsize12">
                        {val.b_description ||
                          `Sed ut perspiciatis unde omnis iste natus error sit
                        voluptatem accusantium doloremque laudantium`}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                </SwiperSlide>
              );
            })}
        </Swiper>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  // console.log("homemap", JSON.stringify(state.Home.home.GETITV));
  return {
    getitv: state.Home.home.GETITV,

    // dashboard: state.dashboard.dashboard,
    // document: state.document.document,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getITVAction: async () => await dispatch(getITVAction()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
